export default "__VITE_ASSET__BPwzMtHX__"